<template>
  <div
    class="bg-home bg-img mobile-topbar-toggle big-footer d-flex flex-column"
    :class="userCustomization.userGroup === 'B2C' ? 'b2c-user' : ''"
  >
    <div
      class="flex-grow-1 d-flex flex-column"
      v-if="userCustomization.userGroup !== 'B2C'"
    >
      <div class="flex-grow-1">
        <section class="d-flex align-items-stretch flex-grow-1">
          <div class="row mx-0 px-3 col-sm-12 pt-4 flex-grow-1">
            <!-- UserCard section -->
            <Transition appear name="fade-slide">
              <div
                class="col-sm-12 col-md-10 offset-md-1 col-lg-5 offset-lg-0 col-xl-5 px-0"
                :class="isWideScreen ? 'pr-4' : ''"
              >
                <UserCard :arr="'column'" :showBtn="true"></UserCard>

                <!-- B2C 用戶的活動 banner (顯示在 UserCard 下方) -->
                <div
                  v-show="userCustomization.userGroup === 'B2C'"
                  class="b2c-banner"
                  :class="
                    userCustomization.userGroup === 'B2C' ? 'mt-1' : 'mt-4'
                  "
                >
                  <HomeEvent :loadingFinish="loadingFinish"></HomeEvent>
                </div>
              </div>
            </Transition>

            <!-- 網頁版右欄 -->
            <div class="col-md-12 col-lg-7 col-xl-7 px-0 d-flex flex-column">
              <!-- 活動banner (僅非 B2C 用戶顯示) -->
              <Transition
                v-if="userCustomization.userGroup !== 'B2C'"
                appear
                name="fade-slide"
                :style="{ transitionDelay: '0.3s' }"
              >
                <HomeEvent :loadingFinish="loadingFinish"></HomeEvent>
              </Transition>
              <!-- END 活動banner  -->
              <!-- 我的班級 -->
              <Transition
                appear
                name="fade-slide"
                :style="{ transitionDelay: '0.6s' }"
              >
                <div class="myclass">
                  <div
                    class="col-md-8 offset-md-2"
                    :class="userCustomization.userGroup === 'B2C' ? '' : 'my-3'"
                  >
                    <div class="ribbon-wrapper">
                      <div
                        class="ribbon bg-danger"
                        :class="
                          userCustomization.userGroup === 'B2C' ? '' : 'my-3'
                        "
                      >
                        <div class="ribbon-content letter-spacing">
                          {{ $t("my-class") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <ClassCard />
                </div>
              </Transition>
              <!-- END 我的班級 -->
              <!-- 任務三塊，僅大螢幕顯示 -->
              <!-- HomeTaskCard -->
              <Transition
                appear
                name="fade-slide"
                :style="{ transitionDelay: '0.9s' }"
              >
                <HomeTaskCard class="pt-2"></HomeTaskCard>
              </Transition>
              <!-- END 任務三塊，僅大螢幕顯示 -->
            </div>
          </div>
        </section>
        <!--END PAGE CONTENT -->
      </div>
    </div>
    <div v-else class="col-12 col-sm-12 d-flex justify-content-center">
      <div class="col-12 col-sm-8 mt-4">
        <UserCardB2C :arr="'column'" :showBtn="true"></UserCardB2C>
      </div>
    </div>

    <!-- HOME FOOTER -->
    <!-- <HomeFooter></HomeFooter> -->
    <!-- END HOME FOOTER -->
    <!-- END CONTENT WRAPPER -->
    <!-- SIDEBAR QUICK PANNEL WRAPPER -->

    <!-- END SIDEBAR QUICK PANNEL WRAPPER -->
    <!-- Vertically centered modal demo-->
    <HomeActivityModal></HomeActivityModal>
    <!-- END Modal -->
    <!-- DailyLoginModal -->
    <DailyLoginModal></DailyLoginModal>
    <!-- ENd MOdal -->
    <LevelCheckModalVue></LevelCheckModalVue>
    <!-- <NotifyModal></NotifyModal> -->
  </div>
</template>

<script setup>
import UserCard from "@/components/UserCard.vue";
import UserCardB2C from "@/components/UserCardB2C.vue";
import HomeTaskCard from "@/components/HomeTaskCard.vue";
import ClassCard from "../components/ClassCard.vue";
import HomeActivityModal from "@/components/HomeActivityModal.vue";
import HomeEvent from "@/components/HomeEvent.vue";
import DailyLoginModal from "@/components/Modal/DailyLoginModal.vue";
import LevelCheckModalVue from "../components/Modal/LevelCheckModal.vue";
// import NotifyModal from "@/components/Modal/NotificationModal.vue";
import {
  ApiGetLearnInfo,
  ApiCheckIn,
  ApiGetDailyCheck,
} from "@/service/apis/learnInfo";
import { ApiGetStudentSubscriptionStatus } from "@/service/apis/class";
import { useClassStore } from "@/store/modules/class";
import { useUserInfoStore } from "@/store/modules/userInfo";
import { useGlobalStore } from "@/store/modules/global";
import { useUserCustomizationStore } from "@/store/modules/userCustomization";

const $screenType = inject("$screenType");
const global = useGlobalStore();
const cs = useClassStore();
const userInfo = useUserInfoStore();
const userCustomization = useUserCustomizationStore();
const loadingFinish = ref(false);
const homeEventBanner = ref(null);

// Daily check related variables
const myDate = ref(null);
const fromDate = ref(null);
const attributes = ref(null);
const thisMonthLogin = ref([]);
const date = new Date();
const year = ref(null);
const month = ref(null);
// const getIns = computed(() => {
//   return userInfo.ins;
// });
const router = useRouter();
const subscriptionStatus = ref(null);

// 獲取學生訂閱狀態
const getSubscriptionStatus = async (studentId) => {
  try {
    const result = await ApiGetStudentSubscriptionStatus.get(studentId);
    console.log("學生訂閱狀態:", result);
    subscriptionStatus.value = result;
    return result;
  } catch (error) {
    console.error("獲取訂閱狀態失敗:", error);
    return null;
  }
};

const getLearnInfo = async () => {
  let result = await ApiGetLearnInfo.get();

  if (result.status === "success") {
    homeEventBanner.value = result.institution.banner;
    cs.$patch((state) => {
      state.classList = result.course;
    });
    userInfo.$patch((state) => {
      state.student.studentName = result.studentinfo[0].username;
      state.student.firstName = result.studentinfo[0].firstname;
      state.student.lastName = result.studentinfo[0].lastname;
      state.student.school = result.institution;
      state.student.level = result.studentinfo[0].cur_lvl;
      if (result.studentinfo[0].amt_exp === 0) {
        state.student.amt_exp = 100;
      } else {
        state.student.amt_exp = result.studentinfo[0].amt_exp;
      }
      // state.student.amt_exp = result.studentinfo[0].amt_exp;
      state.student.exp = result.studentinfo[0].exp;
      state.student.image = result.studentinfo[0].image;
      state.student.title = result.studentinfo[0].title;
      state.student.titleid = result.studentinfo[0].titleid;
      state.student.titlelv = result.studentinfo[0].title_lvl;
      state.hint.totalAssignmentNum = result.totalAssignmentNum;
      state.hint.totalEchoValleyNum = result.totalEchoValleyNum;
      state.hint.totalReward = result.totalReward;
      // institution
      state.institution = result.institution;

      // 設置 stuID（如果還沒有設置的話）
      if (!state.student.stuID && result.studentinfo[0].stuid) {
        state.student.stuID = result.studentinfo[0].stuid;
      }
    });

    // 獲取學生訂閱狀態
    if (result.studentinfo[0].stuid) {
      await getSubscriptionStatus(result.studentinfo[0].stuid);
    }

    // 根據 API 回傳的 user_type 設定用戶群組
    if (
      result.studentinfo[0].remark &&
      result.studentinfo[0].remark.user_type
    ) {
      const userType = result.studentinfo[0].remark.user_type;
      userCustomization.setUserGroup(userType);
    } else {
      // 如果沒有 user_type，設定為 default
      userCustomization.setUserGroup("default");
    }

    // 在用戶群組設定完成後，才設定 loadingFinish
    loadingFinish.value = true;
  } else {
    setTimeout(() => {
      localStorage.clear();
      router.push({
        path: "/",
      });
    }, 1000);
  }
  let needLevelcheck = result.studentinfo[0].plcmt_redo;
  // needLevelcheck = true;
  if (needLevelcheck !== "false") {
    $(`#level-check-modal`).modal("show");
  }
  if (result.checkInRecord !== "true" && needLevelcheck === "false") {
    dailyCheckIn();
  }
};
watch(
  () => userInfo.student.checkInRecord,
  (nval, oval) => {
    if (nval !== "true") {
      dailyCheckIn();
    }
  }
);
const dailyCheckIn = async () => {
  let result = await ApiCheckIn.get();
  console.log(result);
  if (result.record === "done") {
    $(`#modal-daily-checkin`).modal("show");
  }
};

// Daily check function similar to DailyLogin.vue
const getDailyCheck = async () => {
  let result = await ApiGetDailyCheck.get(year.value, month.value);
  if (result.status === "success") {
    console.log("Daily check result:", result);
    myDate.value = [];
    result.record.forEach((item) => {
      item.record.forEach((day) => {
        myDate.value.push(new Date(item.date.year, item.date.month - 1, day));
        if (item.date.month === month.value && year.value === item.date.year) {
          thisMonthLogin.value.push(day);
        }
      });
    });
    console.log("This month login days:", thisMonthLogin.value);
    console.log("All login dates:", myDate.value);
    attributes.value = [
      {
        highlight: true,
        content: "red",
        dates: myDate.value,
        excludeDates: null,
        order: 0,
      },
    ];
  }
};
onUpdated(() => {});

if (localStorage.getItem("needReload") === "true") {
  // console.log("reload");
  // localStorage.setItem("needReload", "false");
  // window.location.reload();
}
const isWideScreen = computed(() => {
  return window.innerWidth >= 1200;
});

// 確保 UI 能正確響應用戶群組變化
const currentUserGroup = computed(() => {
  return userCustomization.userGroup;
});

// 監聽用戶群組變化，確保 banner 正確顯示
watch(
  () => userCustomization.userGroup,
  (newGroup, oldGroup) => {
    // 確保 loadingFinish 已經設定
    if (!loadingFinish.value) {
      loadingFinish.value = true;
    }
  },
  { immediate: true }
);

// 監聽 loadingFinish 變化
watch(
  () => loadingFinish.value,
  (newValue) => {
    // 可以添加其他邏輯
  }
);

// const handleResize = () => {
//   isWideScreen = window.innerWidth >= 1200;
// };
onMounted(() => {
  // 從 localStorage 恢復狀態
  userCustomization.initFromLocalStorage();

  // 這是有用的，usercard要改變狀態，不要刪
  getLearnInfo();

  // Initialize date variables for daily check
  year.value = date.getFullYear();
  month.value = date.getMonth() + 1;

  // Call daily check API to record daily login
  getDailyCheck();

  // window.addEventListener("resize", handleResize());
  // handleResize();
});
</script>
<style lang="scss" scoped>
.bg-home {
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media (max-width: 991.98px) {
  .bg-home {
    min-height: 100vh; // 預設值（所有用戶）
  }

  // B2C 用戶在平板模式下的特殊處理
  .bg-home.b2c-user {
    min-height: 95vh;
    height: auto;
  }

  // 在平板模式下調整內容區域
  section {
    height: 100%;
    flex: 1;
  }

  .row {
    height: 100%;
  }

  // 確保右欄內容能夠填充剩餘空間
  .col-md-12 {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}

// 保持原有的動畫樣式
.fade-slide-enter-active {
  transition: all 0.8s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}

// B2C 用戶專用樣式
.b2c-banner {
  .carousel-2 {
    .slick-prev,
    .slick-next {
      display: none !important; // 隱藏箭頭按鈕
    }
  }

  .carousel-2.slider {
    margin-bottom: 0 !important;
  }

  // 覆蓋 slick-theme 的 margin-bottom
  .slick-dotted.slick-slider {
    margin-bottom: 0 !important;
  }

  // 更全面的選擇器
  .slider {
    margin-bottom: 0 !important;
  }

  // B2C 專用的 banner 樣式
  .fixed-banner-height {
    height: 100px !important;
    object-fit: contain;
    width: 100%;
  }
}
</style>
